import script from "./Co2QuestionForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuestionForm.vue?vue&type=script&lang=ts&setup=true"

import "./Co2QuestionForm.vue?vue&type=style&index=0&id=1f1c8631&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1c8631"]])

export default __exports__